// usersThunk.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchSearchedUsersList, fetchUserProfile, fetchUsersList, resetPassword, updateUserProfile, updateUserStatus, sendUserInvite } from "../../services/UsersService";


// Thunk to fetch users
export const fetchUsersListAsync = createAsyncThunk(
  "users/fetchUsersList",
  async ({ page, per_page, orgId }: { page: number; per_page: number; orgId: number }, { rejectWithValue }) => {
    try {
      const response = await fetchUsersList(page, per_page, orgId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/// Thunk to fetch matching organizations
export const fetchSearchedUsersListAsync = createAsyncThunk(
  "users/fetchSearchedUsersList",
  async ({ page, per_page, orgId, searchString }: { page: number; per_page: number; orgId: number; searchString: string|undefined }, { rejectWithValue }) => {
    try {
      const response = await fetchSearchedUsersList(page, per_page, orgId, searchString); // Use the correct service function
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserProfileAsync = createAsyncThunk(
  "users/fetchUserProfile",
  async ({ UserId }: { UserId: string }, { rejectWithValue }) => {
    try {
      const response = await fetchUserProfile(UserId); // Use the correct service function
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const resetPasswordAsync = createAsyncThunk(
  "users/resetPassword",
  async ({ email }: { email: string }, { rejectWithValue }) => {
    try {
      const response = await resetPassword(email);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateUserProfileAsync = createAsyncThunk(
  "users/updateUserProfile",
  async ({ userId, userData }: { 
    userId: string; 
    userData: {
      first: string;
      last: string;
      email: string;
      user_role: string;
      mobile_phone: string;
      external_unique_id: string;
      organization_id: number;
    }
  }, { rejectWithValue }) => {
    try {
      const response = await updateUserProfile(userId, userData);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response || error.message);
     
    }
  }
);

export const updateUserStatusAsync = createAsyncThunk(
  "users/updateUserStatus",
  async ({ userId, isActive }: { userId: string; isActive: boolean }, { rejectWithValue }) => {
    try {
      const response = await updateUserStatus(userId, isActive);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Additional thunks can be added here as needed
// /master-data/users/{user_id}/send-invite
export const sendUserInviteAsync = createAsyncThunk(
  "users/sendUserInvite",
  async ({ userId }: { userId: string }, { rejectWithValue }) => {
    try {
      const response = await sendUserInvite(userId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


